export default __webpack_public_path__ + "static/media/logoBAS.21b8d67d.png";